import { render } from "./infoOfSpecialist.vue?vue&type=template&id=41fd3506"
import script from "./infoOfSpecialist.vue?vue&type=script&lang=js"
export * from "./infoOfSpecialist.vue?vue&type=script&lang=js"

import "./infoOfSpecialist.vue?vue&type=style&index=0&id=41fd3506&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__